






































































































































































































import { Prop, Vue, Component } from 'vue-property-decorator';
import Uploader from '@/components/next/NewUploader.vue';
import {
  prizeConfig,
  userPrize,
  userList,
  userMessage,
  checkUserExist,
} from '../api';
import { FileType } from '@/common/ts/enum';
import { Toast, Popup, ImagePreview } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';
Vue.use(Popup);
@Component({
  components: {
    Uploader,
  },
})
export default class Home extends Vue {
  @Prop({ default: FileType.Image }) fileType!: FileType;
  img: any = [
    { url: require('../assets/zhongqiu/prizeImg/p1.png'), id: 1 },
    { url: require('../assets/zhongqiu/prizeImg/p2.png'), id: 2 },
    { url: require('../assets/zhongqiu/prizeImg/p3.png'), id: 3 },
    { url: require('../assets/zhongqiu/prizeImg/p4.png'), id: 4 },
    { url: require('../assets/zhongqiu/prizeImg/p5.png'), id: 5 },
    { url: require('../assets/zhongqiu/prizeImg/p6.png'), id: 6 },
    { url: require('../assets/zhongqiu/prizeImg/p7.png'), id: 7 },
    { url: require('../assets/zhongqiu/prizeImg/p8.png'), id: 8 },
  ];
  activity: number = 0;
  userMessage: any = {};
  datahistory: any = [];
  isshowdata: boolean = false;
  tab: any = [{ text: '打卡记录' }, { text: '中奖记录' }];
  idx: any = this.$route.query.idx;
  getPrizeList: any[] = [];
  prizeList: any[] = [];
  wxheadimg: string = '';
  tolookprize() {
    window.location.href =
      '';
  }
  tolookprizet() {
    window.location.href =
      'https://tb.ele.me/wow/alsc/mod/1a30c968f0ea9b41f4d5e8b3';
  }
  tolookprizeth() {
    window.location.href =
      'https://s.t3go.cn/14RkM2sNo';
  }
  created() {
    this.intoact();
    this.wxheadimg = window.localStorage.getItem('headimgurl') + '';
    if (this.idx === '2') {
      this.activity = 1;
    } else {
      this.activity = 0;
    }
    const unionId = window.localStorage.getItem('unionid');
    userList(unionId + '').then((res: any) => {
      console.log('res:::', res.data);
      if (res.code === 200) {
        this.userMessage = res.data.userMessage;
        this.datahistory = res.data.data;
        if (!res.data.data) {
          this.isshowdata = true;
        }
      } else {
        this.isshowdata = true;
      }
    });
    userPrize(unionId + '').then((res: any) => {
      if (res.code === 200) {
        this.getPrizeList = res.data;
      }
    });
    prizeConfig().then((res: any) => {
      this.prizeList = res.data;
    });
  }
  shareCard() {
    const unionId = window.localStorage.getItem('unionid');
    userMessage(unionId + '').then((res: any) => {
      if (res.code === 200) {
        this.$router.push('turndetail?id=' + res.data);
      } else {
        Toast(res.msg);
        return false;
      }
    });
  }
  changeActivity(index: any) {
    this.activity = index;
  }
  onUploadFileClick(fileUrl: string, type: FileType) {
    if (type === FileType.Image) {
      ImagePreview({
        images: [fileUrl],
        showIndicators: false,
        showIndex: false,
      });
    }
  }
  intoact() {
    const unionId = window.localStorage.getItem('unionid');
    console.log(unionId);
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      this.$router.push('home');
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
    } else {
      checkUserExist(unionId + '').then((res: any) => {
        if (!res.data) {
          this.$router.push('citysort');
        }
      });
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
